import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const migrateGuestCart = createAsyncThunk("/home/product/migrate-cart", async ({ userId, guestId }, { rejectWithValue, fulfillWithValue }) => {
  try {
    const { data } = await api.post("/home/product/migrate-cart", {
      userId,
      guestId,
    });
    console.log(data);
    localStorage.removeItem("guestId");
    return fulfillWithValue(data);
  } catch (error) {
    console.error("Error en migración:", error);
    return rejectWithValue(error.response?.data || { error: "Error desconocido" });
  }
});
// End Method

export const guestcartReducer = createSlice({
  name: "guestcart",
  initialState: {
    loading: false,
    errorMessage: "",
    successMessage: "",
    migrationStatus: "idle",
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
    resetMigrationStatus: state => {
      state.migrationStatus = "idle";
    },
  },
  extraReducers: builder => {
    builder
      .addCase(migrateGuestCart.pending, state => {
        state.loading = true;
        state.migrationStatus = "loading";
      })
      .addCase(migrateGuestCart.rejected, (state, { payload }) => {
        state.loading = false;
        state.errorMessage = payload?.error || "Error en la migración del carrito";
        state.migrationStatus = "failed";
      })
      .addCase(migrateGuestCart.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.successMessage = payload?.message || "Carrito migrado exitosamente";
        state.migrationStatus = "succeeded";
      });
  },
});
export const { messageClear, resetMigrationStatus } = guestcartReducer.actions;
export default guestcartReducer.reducer;
